(function($){

	let btn = $('.lnm-account-user-activity__btn-ticket');

	if( !btn || btn.length < 1 ){
		return;
	}

	btn.on('click', function(e){
		e.preventDefault();

		let user_id = $(this).data('userId');
		let event_id = $(this).data('eventId');

		sendAjaxRequest(user_id, event_id);
	});

	function sendAjaxRequest(user_id,event_id){
		console.log(user_id, event_id);
		$.ajax({
	        type: "POST",
	        dataType: "html",
	        url: var_lnm_ajax.url,
	        data: {
	        	action : var_lnm_ajax.action,
				nonce: var_lnm_ajax.nonce,
				callback: 'lnm-show-ticket',
				ticketData: { user_id: user_id, event_id: event_id },
	        },
	        success: function(response){

	        		// select
					var t = document.querySelector('#lnm-account-ticket-modal-template');

					// add to document DOM
					var clone = document.importNode(t.content, true); // where true means deep copy
					document.body.appendChild(clone)

					$('#lnm-account-ticket-modal__ticket').append(response);

	        		let ticket = document.querySelector("#lnm-ticket");
					let container = document.querySelector('#lnm-ticket-qr');

				    var qrcode = new QRCode("lnm-ticket-qr", {
				        text: container.dataset.qr,
				        width: 140,
				        height: 140,
				        colorDark : "#000000",
				        colorLight : "#ffffff",
				        correctLevel : QRCode.CorrectLevel.H
				    });

					html2canvas( ticket, {
						backgroundColor: null
					} ).then(canvas => {
					    document.querySelector('#lnm-ticket-canvas').appendChild(canvas)

					    $('body').addClass('lnm-has-modal');

						$('#lnm-account-ticket-modal').animate({
								opacity: 1
							}, 500);

						$('.lnm-account-ticket-modal__close-btn').on('click', function(e){
							e.preventDefault();
							$('#lnm-account-ticket-modal').animate({
								opacity: 0
							}, 500, function(){
								$('#lnm-account-ticket-modal').remove()
							});
						})

						$('body').removeClass('lnm-has-modal');

					})

					

	        },
	        error : function(jqXHR, textStatus, errorThrown) {
	        	console.log('Error desconocido en newsletter ajax');
	        	console.log(errorThrown);
	        }

	    }); // $.ajax
	}

            





})(jQuery);